/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router';
import i18n from 'i18n';
import Button from 'components/Button';
import {
  connectAsRequest,
  startServerRequest,
  stopServerRequest,
} from 'modules/environments/actions';
import { ServerFields } from 'modules/environments/interfaces';
import { modalOpen, modalClose } from 'modules/modal/actions';
import { Query } from 'hooks/useTableFilters';
import { useDispatch } from 'react-redux';
import { PartnerServersFields } from 'modules/partners/interfaces';
import FormConnectAs from '../FormConnectAs';

export const useServerActions = (query?: Query) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();

  const handleConnect = (instanceId: string, username: string) =>
    dispatch(
      modalOpen({
        title: i18n.t('CONNECT_KEY'),
        maxWidth: 'xs',
        content: (
          <FormConnectAs
            onCancel={modalClose}
            onSubmit={({ password }) => {
              dispatch(
                connectAsRequest({
                  environmentUuid: id,
                  instanceId,
                  values: {
                    ad_username: username,
                    operator_password: password,
                  },
                })
              );
            }}
          />
        ),
      })
    );

  const handleStartServer = (
    item: ServerFields | PartnerServersFields,
    environmentUuid?: string,
    partnerUuid?: string,
    server_type?: string
  ) =>
    dispatch(
      modalOpen({
        title: i18n.t('WANT_START_SERVER_KEY'),
        content: i18n.t('ENVIRONMENTS_PAGE.START_SERVER_MSG_KEY', {
          environment: item?.name,
        }),
        footer: (
          <Grid>
            <Button
              submitButton
              id="submit-button"
              onClick={() => {
                dispatch(
                  startServerRequest({
                    id: item?.instance_id,
                    environmentUuid: environmentUuid || id,
                    query,
                    partnerUuid,
                    server_type: server_type || item?.server_type,
                  })
                );
                dispatch(modalClose());
              }}
            >
              {i18n.t('START_KEY')}
            </Button>
            <Button
              id="cancel-button"
              variant="outlined"
              onClick={() => dispatch(modalClose())}
            >
              {i18n.t('CANCEL_KEY')}
            </Button>
          </Grid>
        ),
      })
    );

  const handleStopServer = (
    item: ServerFields | PartnerServersFields,
    environmentUuid?: string,
    partnerUuid?: string,
    server_type?: string
  ) =>
    dispatch(
      modalOpen({
        title: i18n.t('WANT_STOP_SERVER_KEY'),
        content: i18n.t('ENVIRONMENTS_PAGE.STOP_SERVER_MSG_KEY', {
          environment: item?.name,
        }),
        footer: (
          <Grid>
            <Button
              submitButton
              id="submit-button"
              onClick={() => {
                dispatch(
                  stopServerRequest({
                    id: item?.instance_id,
                    environmentUuid: environmentUuid || id,
                    query,
                    partnerUuid,
                    server_type: server_type || item?.server_type,
                  })
                );
                dispatch(modalClose());
              }}
            >
              {i18n.t('STOP_KEY')}
            </Button>
            <Button
              id="cancel-button"
              variant="outlined"
              onClick={() => dispatch(modalClose())}
            >
              {i18n.t('CANCEL_KEY')}
            </Button>
          </Grid>
        ),
      })
    );

  return {
    handleConnect,
    handleStartServer,
    handleStopServer,
  };
};
